import React, {useEffect, useState} from 'react'
import {Image, Loading, toastManager} from '@therms/atalaya'
import {
  Alerts,
  useCurrentOrganization,
  useCurrentUser,
} from '@therms/react-modules'
import {SetDutyStatus} from '@src/modules/Users/shared/SetDutyStatus'

function UserAnPRestrictedDutyStatusWrapper({
  children,
}: {
  children?: React.ReactNode
}) {
  const {anp, id: userId, status} = useCurrentUser()
  const {logoUrl, name} = useCurrentOrganization()

  const [dutyStatusSetLoading, setDutyStatusSetLoading] = useState(false)

  const showDutyStatus =
    anp.role.ops.restrictions.mustHaveDutyStatusForOPSUse && !status

  useEffect(() => {
    if (!showDutyStatus) {
      // reset loading state
      setDutyStatusSetLoading(false)
    }

    if (dutyStatusSetLoading) {
      const toastId = Alerts.info('Duty Status Set', {
        autoClose: 3000,
        hideProgressBar: false,
      })

      const t = setTimeout(() => {
        // we do this in case the currentUser is not updated via RPCServerEvent, ie: client does not have a WS connection
        window.location.reload()
      }, 3000)

      return () => {
        toastManager.dismiss(toastId)
        clearTimeout(t)
      }
    }

    return undefined
  }, [dutyStatusSetLoading, showDutyStatus])

  if (
    anp.role.ops.restrictions.mustHaveDutyStatusForOPSUse &&
    !status &&
    !anp.role.ops.permissions.canBypassRequiredStatus
  ) {
    return (
      <div className="mt-xxl flex flex-col items-center justify-center">
        {logoUrl && <Image maxHeight={150} src={logoUrl} />}

        {dutyStatusSetLoading ? (
          <Loading message="Loading Duty Status" overlay size="xl" />
        ) : (
          <>
            <div className="mb-base mt-base max-w-[300px] text-center">
              <div className="text-color-main text-lg font-bold">
                Set Your Duty Status
              </div>

              <div className="text-color-neutral text-sm italic">
                <strong>{name}</strong> requires your Duty Status to be set
                before using this app
              </div>
            </div>

            <div className="mb-xxl min-w-[200px]">
              <SetDutyStatus
                onComplete={() => setDutyStatusSetLoading(true)}
                userId={userId}
              />
            </div>
          </>
        )}
      </div>
    )
  }

  return children
}

export {UserAnPRestrictedDutyStatusWrapper}
